import React, {useContext, useEffect, useState} from 'react';
import GettingStartedContext from "../utils/GettingStartedContext";
import PricingCostSection from "./pricingCostSection";
import DownloadPopup from "../containers/download-popup";

const PricingBlock = ({id, defaultPlane, defaultOwnership, disableFlightCalculator, lang, widgetKey,staticBlock}) => {


  const [loaded, setLoaded] = useState(false);

  const {
    link,
    activeHours,
    reloadResults,
    setReloadResults,
    showResult,
    setShowResult,
    data,
    setData,
    result,
    setResult,
    plane,
    setPlane,
    ownership,
    setOwnership,
    plan,
    setPlan,
    hours,
    setHours,
    location,
    setLocation,
    showDownloadPricing,
    setStaticBlock
  } = useContext(GettingStartedContext);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (plane && ownership) {
      loadResults();
    }
  }, [reloadResults]);

  const loadData = async () => {
    await fetch(link + '/getAllContent?block=' + id + '&lang=' + lang + '&aircraft='+defaultPlane)
      .then((response) => response.json())
      .then((json) => {
        setData(json);
        setPlan(json.Options.RelatedPlans[0]);
        setShowResult(true)
        setResult(json.Options);
        if (defaultPlane && defaultOwnership) {
          setPlan(plan)
          setPlane(defaultPlane)
          setOwnership(defaultOwnership);
          setReloadResults(!reloadResults);
        } else {
          setLoaded(true);
        }
      });
      if((document.getElementsByClassName("static-ftc").length > 0)){
        setStaticBlock(true);
      }
  }

  const loadResults = () => {
    fetch(
      link + '/getOnchangeResults?block=' + id + '&lang=' + lang,
      {
        method: 'POST',
        body: JSON.stringify({
          data: {
            plane: plane,
            ownership: ownership,
            plan: plan ? plan.ID : null,
            hours: hours,
            location: location,
          }
        })
      }
    )
      .then((response) => response.json())
      .then((json) => {

        if (!json.BestPlane) {
          json.BestPlane = json.Plane;
        }
        if (!json.BestOwnership) {
          json.BestOwnership = json.Ownership;
        }

        const options = {
          ...data.Options,
          ...json
        }

        setData({
          ...data,
          Options: options
        });
        setPlan(json.Plan);
        setHours(json.Plan.ID);
        setShowResult(true);
        setLoaded(true);
      });
  }

  return <>
    {!loaded && <div>
      Loading
    </div>}
    {!!loaded && <div>
      <PricingCostSection
        widgetKey={widgetKey}
        disableFlightCalculator={disableFlightCalculator}
        exploreOptionTitle={data.exploreButtonTitle}
        exploreOptionLink={data.exploreOptionLink}
        activeHourID={hours} />
    </div>}
    {!!showDownloadPricing && <DownloadPopup />}
  </>
}
export default PricingBlock;
